<template>
  <v-container grid-list-lg fluid>
    <v-layout row align-center>
      <v-flex shrink>
        <v-btn small rounded text @click.stop.prevent="$router.go(-1)">
          <v-icon left>mdi-chevron-left </v-icon>
          <span class="hidden-sm-and-down">Report Dashboard</span>
        </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex shrink class="title text-right">
        Select Batch
      </v-flex>
    </v-layout>
    
    <v-layout row wrap>
      <v-flex xs12 md4>
        <v-select v-if="location" outlined dense :items="locations" v-model="location" label="Select Store" hide-details return-object
          item-text="businessName"></v-select>
        <v-list v-if="location">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium text-capitalize">{{ location.businessName }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ location.address }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs12 md3>
        <DateTimePicker defaultRange="since7DaysAgo" :range="true" :hideTime="true" v-model="dateTime"
          @submit="closeDatePicker" />
      </v-flex>
    </v-layout>

    <div v-if="location">
      <v-data-table v-if="Batches" class="mt-4" :loading="loading"
       :headers="headers" :items="Batches" :sort-by="sortBy" :page.sync="page"
        :items-per-page="itemsPerPage">
        <template v-slot:item="{ item }">
          <tr class="pointer" @click="viewBatchDetail(item)">
            <!-- <td class="text-left small-td pointer" v-if="hidden">
                <v-checkbox :input-value="selected" hide-details> </v-checkbox>
              </td> -->


            <td class="text-left small-td pointer">
              <div>{{ item.OpenDate | moment("MM/DD/YYYY") }}</div>
              <div class="text-capitalize text--disabled font-italic">- {{ item.OpenEmployeeName }}</div>
              <v-icon class="ml-1" small v-if="item.isCanceled" color="red">desktop_access_disabled
              </v-icon>
            </td>
            <td class="text-left small-td pointer">
              <div>{{ item.CloseDate | moment("MM/DD/YYYY") }}</div>
              <div class="text-capitalize text--disabled font-italic">- {{ item.CloseEmployeeName }}</div>
            </td>
            <td class="small-td pointer">{{ item.ShiftCount }}</td>


            <td class="text-right small-td pointer">{{ item.BatchSale | currency }}</td>
            <td class="text-right small-td pointer">{{ item.BatchCash | currency }}</td>
            <td class="text-right small-td pointer">{{ item.BatchOtherPayments | currency }}</td>
          </tr>
        </template>

      </v-data-table>
      <v-card-text v-else>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </div>
    <div v-else>
      <v-layout row wrap justify-center>
        <v-flex shrink>
          <v-card width="350" class="mt-5" outlined>
            <v-card-text class="text-center">
              <v-chip label>Location is not selected</v-chip>
              <div class="mt-5">Select Location</div>
              <v-select outlined dense :items="locations" v-model="location" label="Select Store" hide-details
                return-object item-text="businessName"></v-select>
            </v-card-text>

          </v-card>
        </v-flex>
      </v-layout>
    </div>



  </v-container>
</template>

<script>
import reportService from '@/pages/Report/service.js'
import { mapActions, mapGetters } from 'vuex'
import DateTimePicker from '@/components/DateTimePicker.vue'

export default {
  name: 'batch-selection',
  data() {
    return {
      loading: false,
      selectedDate: null,
      dateTime: {
        start: null,
        end: null,
      },
      location: null,
      Batches: [],
      sortBy: "OpenDate",
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      headers: [
        {
          text: 'Open Date',
          align: "left",
          sortable: true,
          value: "CSPID"
        },
        {
          text: 'Close Date',
          align: "left",
          sortable: false,
          value: "CSPID"
        },
        {
          text: '# of Shift(s)',
          align: "left",
          sortable: false,
          value: "CSPID"
        },
        {
          text: 'Batch Sale',
          align: 'right',
          value: "businessName",
          sortable: false
        },
        {
          text: 'Batch Cash',
          align: 'right',
          value: "address",
          sortable: false
        },
        {
          text: 'Other Payments',
          align: 'right',
          value: "address",
          sortable: false
        },

      ],
    }
  },
  components: {
    DateTimePicker,
  },
  created() {
    console.log('this.$route.params', this.$route.params)
    if (this.$route.params.location) {
      this.location = this.$route.params.location
      this.getBatchList()
    } else {
      if (this.selectedLocation) {
        this.location = this.selectedLocation
      }
    }

  },
  watch: {
    location(val) {
      this.setSelectedLocation(val)
      this.getBatchList()
    }
  },
  computed: {
    ...mapGetters('location', ['locations']),
    ...mapGetters('report', ['batchList', 'selectedLocation'])
  },
  methods: {
    ...mapActions('report', ['setSelectedLocation', 'setBatchList', 'resetBatch']),
    closeDatePicker() {
      this.resetBatch()
      this.getBatchList()
      // console.log('dates', this.dates)
    },
    viewBatchDetail(row) {
      console.log('i got pressed')
      this.$router.push({ name: 'batch-report', params: { batch: row } });
      // const routeData = this.$router.resolve({ name: 'batch-report', params: { batch: row } });
      // window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    getBatchList() {
      if(!this.location) return false

      if (this.batchList) {
        this.Batches = this.batchList
      } else {
        if(!this.dateTime.start) return false
        this.loading = true
        return reportService
          .getBatchList(this.location.storeID, { from: this.dateTime.start.split("T")[0], to: this.dateTime.end.split("T")[0] })
          .then(response => {
            console.log("Batchs", response);
            this.loading = false
            this.Batches = response.data
            this.setBatchList(this.Batches)
            return response;
          }).catch(error => {
            this.loading = false
          })
      }

    }
  }
}
</script>

<style scoped>
</style>